import { Box, Divider, Grid, Typography } from '@mui/material';
import GeneralDataItem from 'src/components/GeneralDataItem';
import GeneralDataItemConditional from 'src/components/GeneralDataItemConditional';
import { FiagroResumeData } from 'src/types/operations/fiagro';

type OperationFIAGROResumeGeneralDataProps = {
  data?: Pick<
    FiagroResumeData['general'],
    | 'cnpjFundo'
    | 'tipoCondominio'
    | 'situacaoFundo'
    | 'tipoResponsabilidadeFundo'
    | 'classificacaoFundo'
    | 'haCogestao'
    | 'categoriaAnexoNormativo'
  >;
};

export default function OperationFIAGROResumeGeneralData({
  data,
}: OperationFIAGROResumeGeneralDataProps) {
  return (
    <Box p={1}>
      <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>
        &mdash;Dados Gerais
      </Typography>
      <Divider sx={{ height: 2, backgroundColor: 'black' }} />
      <Box py={2}>
        <Grid container spacing={0}>
          <Grid item xs={12}>
            <GeneralDataItem title="CNPJ" subtitle={data?.cnpjFundo ?? 'N/D'} />
          </Grid>
          <Grid item xs={12}>
            <GeneralDataItem
              title="Tipo de Condomínio"
              subtitle={data?.tipoCondominio ?? 'N/D'}
            />
          </Grid>
          <Grid item xs={12}>
            <GeneralDataItem
              title="Situação"
              subtitle={data?.situacaoFundo ?? 'N/D'}
            />
          </Grid>
          <Grid item xs={12}>
            <GeneralDataItem
              title="Responsabilidade"
              subtitle={data?.tipoResponsabilidadeFundo ?? 'N/D'}
            />
          </Grid>
          <Grid item xs={12}>
            <GeneralDataItemConditional
              title="Multiclasse"
              condition={data?.classificacaoFundo !== 'Monoclasse'}
            />
          </Grid>
          <Grid item xs={12}>
            <GeneralDataItemConditional
              title="Cogestão"
              condition={data?.haCogestao ?? false}
            />
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}
